import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
  selector: 'app-language-dropdown', standalone: true,
  imports: [CommonModule, NgbDropdownModule, TranslateModule],
  template: `
    <div ngbDropdown #dropdown="ngbDropdown" class="language-drop-dv" placement="bottom-end" container="body" dropdownClass="hungery-language-popup">
      <button type="button" class="btn btn-language" [id]="controlId" ngbDropdownToggle
              [attr.aria-label]="'TOUR.LANGUAGE' | translate">
        {{ language.getCurrentLang() === 'zh-TW' ? '繁中' : (language.getCurrentLang() | uppercase) }}
      </button>
      <div ngbDropdownMenu [attr.aria-labelledby]="controlId" class="project-dropdown language-dropdown-menu tour-language-menu">
        <button *ngFor="let option of options" ngbDropdownItem (click)="select(option.code); dropdown.close()"
                [class.active]="language.getCurrentLang() === option.code" [attr.lang]="option.code">{{ option.label }}</button>
      </div>
    </div>`,
  styleUrls: ['./language-dropdown.component.scss']
})
export class LanguageDropdownComponent {
  @Input() controlId = 'site-language';
  readonly options = [
    { code: 'en', label: 'English' }, { code: 'id', label: 'Indonesian' },
    { code: 'zh-TW', label: '繁體中文（台灣）' }
  ];
  constructor(public language: TranslationService) {}
  select(code: string): void {
    this.language.changeLanguage(code);
    this.language.changeLang(code);
  }
}
